import { defineStore } from 'pinia'

export const useGlobal = defineStore('global', () => {
  const runtimeConfig = useRuntimeConfig()
  const { baseURL } = runtimeConfig.public

  const isXsOnly = ref(false) //            ? < 768
  const isSmOnly = ref(false) //     768 <= ? < 992
  const isSmAndDown = ref(false) //         ? < 992
  const isSmAndUp = ref(false) //    768 <= ?
  const isMdOnly = ref(false) //     992 <= ? < 1200
  const isMdAndDown = ref(false) //         ? < 1200
  const isMdAndUp = ref(false) //    992 <= ?
  const isLgOnly = ref(false) //    1200 <= ? < 1920
  const isLgAndDown = ref(false) //         ? < 1920
  const isLgAndUp = ref(false) //   1200 <= ?
  const isXlOnly = ref(false) //    1920 <= ?
  const screenWidth = ref(0)
  const screenHeight = ref(0)
  const idleCountDownSeconds = ref(0)
  const idleDeadline = ref(useLocalStorage(`${baseURL.replaceAll('/', '-')}-idleDeadline`, Date.now()))
  const idleDeadlineCurrentPageCache = ref(0)
  const countDownInterval = ref<NodeJS.Timeout | undefined>()
  const idleCountDownSecondsCurrentPageCache = ref(0)

  function setScreenWidth(value) {
    screenWidth.value = value
    isXsOnly.value = value < 768
    isSmOnly.value = value >= 768 && value < 992
    isSmAndDown.value = value < 992
    isSmAndUp.value = value >= 768
    isMdOnly.value = value >= 992 && value < 1200
    isMdAndDown.value = value < 1200
    isMdAndUp.value = value >= 992
    isLgOnly.value = value >= 1200 && value < 1920
    isLgAndDown.value = value < 1920
    isLgAndUp.value = value >= 1200
    isXlOnly.value = value >= 1920
  }

  function setScreenHeight(value) {
    screenHeight.value = value
  }

  function setIdleCountDownSeconds(value) {
    idleCountDownSeconds.value = value
    if (value > 0) {
      idleDeadline.value = Date.now() + value * 1000
      idleDeadlineCurrentPageCache.value = idleDeadline.value
    }
  }

  function idleCountDown(onTimesUp) {
    clearInterval(countDownInterval.value)
    if (idleCountDownSeconds.value <= 0)
      return
    countDownInterval.value = setInterval(() => {
      const countDownSeconds = Math.floor((idleDeadline.value - Date.now()) / 1000)
      idleCountDownSeconds.value = countDownSeconds
      if (countDownSeconds <= 0) {
        clearInterval(countDownInterval.value)
        onTimesUp()
      }
    }, 1000)
  }

  return {
    isXsOnly,
    isSmOnly,
    isSmAndDown,
    isSmAndUp,
    isMdOnly,
    isMdAndDown,
    isMdAndUp,
    isLgOnly,
    isLgAndDown,
    isLgAndUp,
    isXlOnly,
    screenWidth,
    screenHeight,
    idleCountDownSeconds,
    idleCountDownSecondsCurrentPageCache,
    setScreenWidth,
    setScreenHeight,
    setIdleCountDownSeconds,
    idleCountDown,
  }
})
